var cilMinus = ["512 512", "<rect width='368' height='32' x='72' y='240' fill='var(--ci-primary-color, currentColor)' class='ci-primary'/>"];

export { cilMinus };

